<template>
  <div>
    <div class="row col-11 mx-auto">
      <div class="col">
        <section class="p-2 col-md-8 mx-auto">
          <h2 class="text-center my-4">Добавить Работника</h2>
          <form>
            <!--            <label>Личный код курьера</label>-->
            <input type="tel" v-model="manCode" @click="manCodeNumpad()" placeholder="Личный код курьера">
            <small class="form-text text-muted">
              Бот присылает курьеру код после успешной регистрации.
            </small>
            <div class="d-flex justify-content-end">
              <button class="mb mt-2"
                      type="button" @click="createNewMapping">
                Добавить
              </button>
            </div>
          </form>
          <b-alert
            class="mt-4"
            :show="dismissCountDown"
            dismissible
            fade
            :variant="variant"
            @dismissed="dismissCountDown=0"
            @dismiss-count-down="countDownChanged"
          >
            <p>{{ alertMessage }}</p>
            <b-progress
              :variant="variant"
              :max="dismissSecs - 1"
              :value="dismissCountDown - 1"
              height="4px"
            ></b-progress>
          </b-alert>
        </section>
      </div>
    </div>

    <Numpad ref="manCodeEnter" @get-text="manCode = $event"></Numpad>
  </div>
</template>

<script>
import axios from 'axios';
import Numpad from './Numpad';

export default {
  components: {
    Numpad,
  },
  name: 'DeliveryManAdd',
  data() {
    return {
      dismissSecs: 5,
      dismissCountDown: 0,
      variant: '',
      alertMessage: '',
      manCode: null,
    };
  },
  methods: {
    countDownChanged(dismissCountDown) {
      this.dismissCountDown = dismissCountDown;
    },
    showAlert(variant) {
      this.variant = variant;
      this.dismissCountDown = this.dismissSecs;
    },
    back() {
      history.back();
    },
    createNewMapping() {
      if ((this.manCode == null) || (this.manCode === '')) {
        this.alertMessage = 'Ошибка: Пустой ввод.';
        this.showAlert('danger');
      } else if (!/\d+$/.test(this.manCode)) {
        this.alertMessage = 'Ошибка: Неверный формат ввода.';
        this.showAlert('danger');
      } else {
        axios
          .post(`//${window.location.host}/api/v1/rest-mapping`, {
            merchantHash: this.$store.state.merchantHash,
            restId: this.$store.state.restId,
            manCode: this.manCode,
          })
          .then((response) => {
            // eslint-disable-next-line no-console
            console.log(response.data);
            if (response.data.success) {
              if (response.data.created) {
                this.alertMessage = 'Работник добавлен!';
                this.showAlert('success');
              } else {
                this.alertMessage = 'Этот Работник был добавлен ранее.';
                this.showAlert('warning');
              }
            } else {
              this.alertMessage = `Ошибка: ${response.data.error}`;
              this.showAlert('danger');
            }
          })
          .catch((error) => {
            // eslint-disable-next-line no-console
            console.log(error);
            this.alertMessage = 'Ошибка: Неизвестная ошибка.';
            this.showAlert('danger');
          });
      }
    },
    manCodeNumpad() {
      this.$refs.manCodeEnter.show();
    },
  },
};
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/DeliveryManAdd.vue